/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedTripPlannerRouteImport } from './routes/_authenticated/trip-planner'
import { Route as AuthenticatedStationsRouteImport } from './routes/_authenticated/stations'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPricingRouteImport } from './routes/_authenticated/pricing'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCompaniesRouteImport } from './routes/_authenticated/companies'
import { Route as AuthenticatedClosuresRouteImport } from './routes/_authenticated/closures'
import { Route as AuthenticatedChargersRouteImport } from './routes/_authenticated/chargers'
import { Route as AuthenticatedBranchesRouteImport } from './routes/_authenticated/branches'
import { Route as AuthenticatedBookAppointmentRouteImport } from './routes/_authenticated/book-appointment'
import { Route as AuthenticatedAppointmentsRouteImport } from './routes/_authenticated/appointments'

const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTripPlannerRoute =
  AuthenticatedTripPlannerRouteImport.update({
    id: '/trip-planner',
    path: '/trip-planner',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedStationsRoute = AuthenticatedStationsRouteImport.update({
  id: '/stations',
  path: '/stations',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPricingRoute = AuthenticatedPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompaniesRoute = AuthenticatedCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClosuresRoute = AuthenticatedClosuresRouteImport.update({
  id: '/closures',
  path: '/closures',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChargersRoute = AuthenticatedChargersRouteImport.update({
  id: '/chargers',
  path: '/chargers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBranchesRoute = AuthenticatedBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBookAppointmentRoute =
  AuthenticatedBookAppointmentRouteImport.update({
    id: '/book-appointment',
    path: '/book-appointment',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAppointmentsRoute =
  AuthenticatedAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/book-appointment': typeof AuthenticatedBookAppointmentRoute
  '/branches': typeof AuthenticatedBranchesRoute
  '/chargers': typeof AuthenticatedChargersRoute
  '/closures': typeof AuthenticatedClosuresRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stations': typeof AuthenticatedStationsRoute
  '/trip-planner': typeof AuthenticatedTripPlannerRoute
  '/users': typeof AuthenticatedUsersRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/appointments': typeof AuthenticatedAppointmentsRoute
  '/book-appointment': typeof AuthenticatedBookAppointmentRoute
  '/branches': typeof AuthenticatedBranchesRoute
  '/chargers': typeof AuthenticatedChargersRoute
  '/closures': typeof AuthenticatedClosuresRoute
  '/companies': typeof AuthenticatedCompaniesRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/pricing': typeof AuthenticatedPricingRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stations': typeof AuthenticatedStationsRoute
  '/trip-planner': typeof AuthenticatedTripPlannerRoute
  '/users': typeof AuthenticatedUsersRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRoute
  '/_authenticated/appointments': typeof AuthenticatedAppointmentsRoute
  '/_authenticated/book-appointment': typeof AuthenticatedBookAppointmentRoute
  '/_authenticated/branches': typeof AuthenticatedBranchesRoute
  '/_authenticated/chargers': typeof AuthenticatedChargersRoute
  '/_authenticated/closures': typeof AuthenticatedClosuresRoute
  '/_authenticated/companies': typeof AuthenticatedCompaniesRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/pricing': typeof AuthenticatedPricingRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/stations': typeof AuthenticatedStationsRoute
  '/_authenticated/trip-planner': typeof AuthenticatedTripPlannerRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/appointments'
    | '/book-appointment'
    | '/branches'
    | '/chargers'
    | '/closures'
    | '/companies'
    | '/dashboard'
    | '/pricing'
    | '/settings'
    | '/stations'
    | '/trip-planner'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/appointments'
    | '/book-appointment'
    | '/branches'
    | '/chargers'
    | '/closures'
    | '/companies'
    | '/dashboard'
    | '/pricing'
    | '/settings'
    | '/stations'
    | '/trip-planner'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/_authenticated/appointments'
    | '/_authenticated/book-appointment'
    | '/_authenticated/branches'
    | '/_authenticated/chargers'
    | '/_authenticated/closures'
    | '/_authenticated/companies'
    | '/_authenticated/dashboard'
    | '/_authenticated/pricing'
    | '/_authenticated/settings'
    | '/_authenticated/stations'
    | '/_authenticated/trip-planner'
    | '/_authenticated/users'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trip-planner': {
      id: '/_authenticated/trip-planner'
      path: '/trip-planner'
      fullPath: '/trip-planner'
      preLoaderRoute: typeof AuthenticatedTripPlannerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stations': {
      id: '/_authenticated/stations'
      path: '/stations'
      fullPath: '/stations'
      preLoaderRoute: typeof AuthenticatedStationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pricing': {
      id: '/_authenticated/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof AuthenticatedPricingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies': {
      id: '/_authenticated/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AuthenticatedCompaniesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/closures': {
      id: '/_authenticated/closures'
      path: '/closures'
      fullPath: '/closures'
      preLoaderRoute: typeof AuthenticatedClosuresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/chargers': {
      id: '/_authenticated/chargers'
      path: '/chargers'
      fullPath: '/chargers'
      preLoaderRoute: typeof AuthenticatedChargersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/branches': {
      id: '/_authenticated/branches'
      path: '/branches'
      fullPath: '/branches'
      preLoaderRoute: typeof AuthenticatedBranchesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/book-appointment': {
      id: '/_authenticated/book-appointment'
      path: '/book-appointment'
      fullPath: '/book-appointment'
      preLoaderRoute: typeof AuthenticatedBookAppointmentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/appointments': {
      id: '/_authenticated/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AuthenticatedAppointmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAppointmentsRoute: typeof AuthenticatedAppointmentsRoute
  AuthenticatedBookAppointmentRoute: typeof AuthenticatedBookAppointmentRoute
  AuthenticatedBranchesRoute: typeof AuthenticatedBranchesRoute
  AuthenticatedChargersRoute: typeof AuthenticatedChargersRoute
  AuthenticatedClosuresRoute: typeof AuthenticatedClosuresRoute
  AuthenticatedCompaniesRoute: typeof AuthenticatedCompaniesRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedPricingRoute: typeof AuthenticatedPricingRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStationsRoute: typeof AuthenticatedStationsRoute
  AuthenticatedTripPlannerRoute: typeof AuthenticatedTripPlannerRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppointmentsRoute: AuthenticatedAppointmentsRoute,
  AuthenticatedBookAppointmentRoute: AuthenticatedBookAppointmentRoute,
  AuthenticatedBranchesRoute: AuthenticatedBranchesRoute,
  AuthenticatedChargersRoute: AuthenticatedChargersRoute,
  AuthenticatedClosuresRoute: AuthenticatedClosuresRoute,
  AuthenticatedCompaniesRoute: AuthenticatedCompaniesRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedPricingRoute: AuthenticatedPricingRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStationsRoute: AuthenticatedStationsRoute,
  AuthenticatedTripPlannerRoute: AuthenticatedTripPlannerRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
